import { lazy } from "react"

export const CustomerFinance = lazy(() => import("./CustomerFinance"))
